import React from 'react';

const ContactUspage = () => {
    // Define styles for different screen sizes
    const getResponsiveStyles = () => {
        const width = window.innerWidth;

        // Base styles matched to the screenshot with improved opacity
        const headingStyle = {
            fontSize: '64px',
            color: 'rgba(255, 255, 255, 1)', // Full opacity for heading
            marginBottom: '30px',
            fontWeight: 'normal',
            fontFamily: '"Source Sans Pro", sans-serif',
            textAlign: 'center',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)' // Subtle shadow for better readability
        };

        const paragraphStyle = {
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)', // Slightly reduced opacity for better readability
            lineHeight: 1.6,
            fontFamily: '"Source Sans Pro", sans-serif',
            textAlign: 'center',
            margin: '0 auto',
            maxWidth: '800px',
            fontWeight: 'normal',
            letterSpacing: '0.2px' // Slightly increased letter spacing for readability
        };

        // Responsive adjustments
        if (width <= 768) {
            headingStyle.fontSize = '48px';
            paragraphStyle.fontSize = '16px';
            paragraphStyle.maxWidth = '600px';
        }

        if (width <= 480) {
            headingStyle.fontSize = '36px';
            paragraphStyle.fontSize = '14px';
        }

        return { headingStyle, paragraphStyle };
    };

    // Main container styles
    const pageStyle = {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#8c1c4d',
        padding: '0',
        margin: '0'
    };

    const containerStyle = {
        width: '100%',
        maxWidth: '1200px',
        textAlign: 'center',
        padding: '80px 20px'
    };



    // Email style
    const emailStyle = {
        fontWeight: 'bold',
        color: 'rgba(255, 255, 255, 1)',
        textDecoration: 'none'
    };

    // Get responsive styles based on current screen size
    const [responsiveStyles, setResponsiveStyles] = React.useState(() => getResponsiveStyles());

    // Update styles when window is resized
    React.useEffect(() => {
        const handleResize = () => {
            setResponsiveStyles(getResponsiveStyles());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={pageStyle}>
            <div style={containerStyle}>
                <h1 style={responsiveStyles.headingStyle}>Contact Us Today</h1>

                <p style={responsiveStyles.paragraphStyle}>
                    Got a question about Beauti? Whether you're a salon owner looking to simplify 
                    your systems, a current user needing support, or just curious about what we do 
                    — we're here for it. Drop us a message and one of our (real, local, industry-
                    savvy) team members will be in touch. We're all about making beauty business 
                    easier — and it starts with great communication. You can contact us directly at 
                </p>
                <p style={{...responsiveStyles.paragraphStyle, fontWeight: 'bold', marginTop: '10px'}}>
                    <a href="mailto:support@beautisoftware.com" style={emailStyle}>support@beautisoftware.com</a>
                </p>
            </div>
        </div>
    );
};

export default ContactUspage;

